import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getImageUrlByDimension } from '@yme/utils/common';
import { DESKTOP_KEY, MOBILE_KEY, TABLET_KEY, THUMBNAIL_KEY } from '@yme/utils/constants';
export const getDimension = ({ isTabletView, isMobileView, isThumbnails, }) => {
    if (isThumbnails) {
        return THUMBNAIL_KEY;
    }
    if (isMobileView) {
        return MOBILE_KEY;
    }
    if (isTabletView) {
        return TABLET_KEY;
    }
    return DESKTOP_KEY;
};
export const useRenditions = ({ imageSrc, isImageExists = true }) => {
    const { isMobileView, isTabletView } = useWindowSize();
    const dimension = getDimension({
        isMobileView,
        isTabletView,
    });
    const imageSrcWithDimension = getImageUrlByDimension({
        src: imageSrc,
        dimension,
    });
    return {
        imageSrcWithDimension: isImageExists ? imageSrcWithDimension : imageSrc,
    };
};
